import axiosInstance from "../helpers/axiosInstance"

export const getStorePackingMaterials = async (warehouseId, storeId) => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/store-packing-materials/store/${storeId}/warehouse/${warehouseId}`)
    return res.data
}
